import { createI18n } from 'vue-i18n'
import en from '@/locales/en';
import th from '@/locales/th';

const messages = {
    en: en,
    th: th,
}

export default createI18n({
    locale: 'th',
    messages,
});
